import { render, staticRenderFns } from "./screenDefenseGame.vue?vue&type=template&id=eab2d5e0&scoped=true&"
import script from "./screenDefenseGame.vue?vue&type=script&lang=js&"
export * from "./screenDefenseGame.vue?vue&type=script&lang=js&"
import style0 from "./screenDefenseGame.vue?vue&type=style&index=0&id=eab2d5e0&prod&lang=scss&scoped=true&"
import style1 from "./screenDefenseGame.vue?vue&type=style&index=1&id=eab2d5e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab2d5e0",
  null
  
)

export default component.exports